import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const TASK_ITEMS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('TASK_ITEMS');
export const TASK_ITEMS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	TASK_ITEMS_CRUD_ACTION_CONSTANTS
);
